import React, { ReactElement } from 'react';
import { maybe } from '@lwtears/lwt-common-frontend/lib/@common/util/maybe-util';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import SectionHeader from '../layout/SectionHeader';
import HeaderPageViewControls from '../modules/Paging/components/HeaderPageViewControls';

type ActivityHeaderLayoutProps = {
  backRoute?: string;
  Footer?: ReactElement;
  hamburgerMenu?: boolean;
  handleClose?: any;
  hasTogglePageView?: boolean;
  Header?: React.FC;
  showCloseButton?: boolean;
  title: string;
  omitRoutes?: string[];
};

const ActivityHeaderLayout: React.FC<ActivityHeaderLayoutProps> = ({
  backRoute,
  children,
  Footer,
  hamburgerMenu = true,
  handleClose,
  hasTogglePageView = false,
  Header = SectionHeader,
  showCloseButton = false,
  title,
  omitRoutes,
}) => {
  const classes = useStyles();

  const MaybeHeaderPageViewControls = maybe(HeaderPageViewControls);

  return (
    <Box className={classes.root}>
      <Header
        title={title}
        hamburgerMenu={hamburgerMenu}
        showCloseButton={showCloseButton}
        backRoute={backRoute}
        closeButtonAction={handleClose}
        omitRoutes={omitRoutes}
      >
        <MaybeHeaderPageViewControls shouldRender={hasTogglePageView} {...{ ariaLabel: 'btn' }} />
      </Header>
      {children}
      {Footer}
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
}));

export default ActivityHeaderLayout;
